module.exports = __webpack_public_path__ + "assets/img/Employment-Inovations-Landing-Page-w960.b5eb6a65.jpg";